import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { submitCallback } from "@/lib/api";

export default function CallbackForm({ plan = "", onSuccess, testPrefix = "callback" }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const update = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your full name and mobile number.");
      return;
    }
    setLoading(true);
    try {
      const source_page =
        typeof window !== "undefined" ? window.location.pathname : "";
      await submitCallback({ ...form, plan, source_page });
      setSuccess(true);
      toast.success("Thank you. Our team will contact you shortly.");
      onSuccess?.();
    } catch (err) {
      toast.error("Could not submit. Please try again or WhatsApp us.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div
        className="rounded-md border border-emerald-200 bg-emerald-50 p-5 text-center"
        data-testid={`${testPrefix}-success`}
      >
        <div className="font-serif text-lg text-emerald-800">Thank you.</div>
        <p className="mt-1 text-sm text-emerald-700">
          Our team will contact you shortly.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${testPrefix}-form`}>
      <div>
        <Label htmlFor={`${testPrefix}-name`}>Full Name *</Label>
        <Input
          id={`${testPrefix}-name`}
          value={form.name}
          onChange={update("name")}
          placeholder="e.g. Priya Sharma"
          className="mt-2"
          data-testid={`${testPrefix}-input-name`}
        />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <Label htmlFor={`${testPrefix}-phone`}>Mobile Number *</Label>
          <Input
            id={`${testPrefix}-phone`}
            value={form.phone}
            onChange={update("phone")}
            placeholder="+91 9XXXXXXXXX"
            className="mt-2"
            data-testid={`${testPrefix}-input-phone`}
          />
        </div>
        <div>
          <Label htmlFor={`${testPrefix}-email`}>Email</Label>
          <Input
            id={`${testPrefix}-email`}
            type="email"
            value={form.email}
            onChange={update("email")}
            placeholder="you@example.com"
            className="mt-2"
            data-testid={`${testPrefix}-input-email`}
          />
        </div>
      </div>
      <div>
        <Label htmlFor={`${testPrefix}-message`}>Optional message</Label>
        <Textarea
          id={`${testPrefix}-message`}
          value={form.message}
          onChange={update("message")}
          placeholder="Anything you'd like us to know"
          className="mt-2"
          rows={3}
          data-testid={`${testPrefix}-input-message`}
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="w-full bg-navy text-white hover:bg-[#1A2642]"
        data-testid={`${testPrefix}-submit-btn`}
      >
        {loading ? "Submitting…" : "Request a Callback"}
      </Button>
    </form>
  );
}
